// Funzione per aggiungere progressi allo storage sicuro
function addProgressVideoToStorage(id, progress) {

    // console.log("ID:" + id + " - PROGRESS " + progress);
    return new Promise((resolve, reject) => {
        db.transaction(function(tx) {
            tx.executeSql('SELECT * FROM download WHERE id = ?', [id], function(tx, result) {
                if (result.rows.length > 0) {
                    // Video già presente nel database, aggiorna il progresso
                    tx.executeSql('UPDATE download SET progress = ? WHERE id = ?', [progress, id], function(tx, result) {

                        //aggiorno interfaccia downloaded
                        updateProgressBars(id, progress);
                        resolve();
                    }, function(error) {
                        console.error("Errore durante l'aggiornamento del progresso:", error);
                        reject(error);
                    });
                } else {
                   // do nothing
                   //notifico che il video è stato cancellato

                }
            }, function(error) {
                console.error("Errore durante il recupero del video dal database:", error);
                reject(error);
            });
        });
    });
}


// Funzione helper che esegue la richiesta HTTP e restituisce una promessa
function httpRequest(url) {
    return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onload = () => {
            if (xhr.status === 200) {
                try {
                    var jsonData = JSON.parse(xhr.responseText);
                    resolve(jsonData);
                } catch (error) {
                    console.error("Errore durante il parsing della risposta JSON:", error);
                    reject(new Error("Errore durante il parsing della risposta JSON"));
                }
            } else {
                reject(new Error("Errore nella richiesta HTTP: " + xhr.statusText));
            }
        };
        xhr.onerror = () => {
            console.error("Errore durante la richiesta HTTP.");
            reject(new Error("Errore durante la richiesta HTTP"));
        };
        xhr.send();
    });
}

async function downloadVideoFiles(id, title, quality) {
    try {
        await new Promise((resolve, reject) => {
            startDownload(id, title, quality);
            resolve();
        });
    } catch (error) {
        console.error("Errore durante il download del video:", error);
    }
}

async function startDownload(id, title=null, quality) {
    // un download riavviato sullo stesso id torna a poter accendere il badge
    try{ resetCancelledDownloadNavBadge(id); }catch(err){}
    refreshListDownloadedIds();
    // window.plugins.toast.showShortBottom("Download started");
    var endpoint = "https://api.teyuto.tv/v2/videos/" + id + "/m3u8-file?quality="+quality;
    // console.log(endpoint);

    try {
        // Uso della funzione httpRequest con await
        var jsonData = await httpRequest(endpoint);
        var masterContent = jsonData.master.file;
        var masterPath = cordova.file.dataDirectory + "video/" + id + "/" + jsonData.master.name;
        // console.log(masterPath);
        // return false;
        await saveFile(masterContent, masterPath, id); // Assicurati che saveFile gestisca correttamente le promesse se necessario
        // createProgressNotification(id, 0, title);

        var dbTransactionCompletedForRemovedElement = false; // Variabile di controllo

        var totDownload = jsonData.download.length;
        for (let index = 0; index < totDownload; index++) {
            if (dbTransactionCompletedForRemovedElement) {
                break; // Interrompi il ciclo se la transazione del database è stata completata
            }

            var fileInfo = jsonData.download[index];
            var filePath = cordova.file.dataDirectory + "video/" + id + "/" + fileInfo.name;

            // Controllo se il video è stato eliminato dal db
            await new Promise((resolve, reject) => {
                db.transaction(async function(tx) {
                    tx.executeSql(
                        'SELECT * FROM download WHERE id = ?',
                        [id],
                        async function(tx, result) {
                            if (result.rows.length > 0) {
                                try {
                                    await checkFileExists(filePath);
                                } catch (error) {
                                    await downloadAndSaveFile(fileInfo.file, filePath, id);
                                }
                            } else {
                                await deleteVideoDownloaded(id);
                                dbTransactionCompletedForRemovedElement = true; // Imposta la variabile di controllo
                            }
                            resolve(); // Risolve la promessa per passare alla prossima iterazione
                        },
                        function(error) {
                            console.error("Errore durante il controllo dell'esistenza del record nel database:", error.message);
                            reject(error); // Rejeta la promessa in caso di errore
                        }
                    );
                });
            });
            ///fine check 


            // Aggiornamento del progresso
            var progress = Math.round(((index + 1) / totDownload) * 100);
            updateProgressNotification(id, progress, title);
        }
        
        if (dbTransactionCompletedForRemovedElement) {
            console.log("Download interrotto");
            return;
        }

        console.log("Download completati");
        updateProgressNotification(id, 100, title);

    } catch (error) {
        console.error("Esco perché si è verificato un problema:", error.message);
        window.plugins.toast.showShortBottom("An error occurred during download, please check your connection or storage space.");
    }
}


// Aggiungi questa funzione per verificare se un file esiste
function checkFileExists(filePath) {
    return new Promise((resolve, reject) => {
        window.resolveLocalFileSystemURL(filePath, resolve, reject);
    });
}


function saveFile(content, path, id) {
    // Utilizza le API di Cordova per salvare il file localmente
    window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function(directoryEntry) {
        directoryEntry.getDirectory("video", { create: true, exclusive: false }, function(videoDirectory) {
            videoDirectory.getDirectory(id.toString(), { create: true, exclusive: false }, function(directory) {
                directory.getFile('master.m3u8', { create: true, exclusive: false }, function(fileEntry) {
                    fileEntry.createWriter(function(fileWriter) {
                        fileWriter.onwriteend = function() {
                            console.log("Salvataggio completato: " + path);
                        };
                        fileWriter.onerror = function(e) {
                            console.error("Errore durante il salvataggio: " + JSON.stringify(e));
                        };
                        fileWriter.write(content);
                    }, function(error) {
                        console.error("Errore durante il recupero del writer: " + JSON.stringify(error));
                    });
                }, function(error) {
                    console.error("Errore durante il recupero del file: " + JSON.stringify(error));
                });
            }, function(error) {
                console.error("Errore durante il recupero della directory del video: " + JSON.stringify(error));
            });
        }, function(error) {
            console.error("Errore durante il recupero della directory 'video': " + JSON.stringify(error));
        });
    }, function(error) {
        console.error("Errore nell'accesso al file system: " + JSON.stringify(error));
    });
}

function downloadAndSaveFile(url, path, id) {
    return new Promise((resolve, reject) => { // Modifica qui
        var fileTransfer = new FileTransfer();
        window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function(directoryEntry) {
            directoryEntry.getDirectory("video", { create: true, exclusive: false }, function(videoDirectory) {
                videoDirectory.getDirectory(id.toString(), { create: true, exclusive: false }, function(directory) {
                    fileTransfer.download(
                        url,
                        path,
                        function(entry) {
                            // console.log("Download completato: " + entry.toURL());
                            resolve(true); // Risolvi la promessa con successo
                        },
                        function(error) {
                            console.error("Errore durante il download: " + JSON.stringify(error));
                            reject(false); // Rifiuta la promessa
                        }
                    );
                });
            });
        });
    });
}

function getLocalFileURL(filePath) {
    return new Promise((resolve, reject) => {
        window.resolveLocalFileSystemURL(filePath,
            function(fileEntry) {
                // alert(fileEntry.toURL());
                resolve(fileEntry.toURL());
            },
            function(error) {
                reject(error);
            }
        );
    });
}
// function createProgressNotification(notificationId, progress, title=null) {
//     try{
//         cordova.plugins.notification.local.schedule({
//             id: notificationId,
//             title: title,
//             text: '...',
//             progressBar: { value: progress },
//             sound: false
//         });
//     }catch(err){}
// }

// function progressCompletedNotification(notificationId, title=null) {
//     try{
//         cordova.plugins.notification.local.update({
//             id: notificationId,
//             title: title+': '+translate('DOWNLOAD_COMPLETED'),
//             // sound: false
//         });

//     }catch(err){}
    
//     addProgressVideoToStorage(notificationId, 100);

// }

function updateProgressNotification(notificationId, progress, title=null) {
    // try{
    //     cordova.plugins.notification.local.update({
    //         id: notificationId,
    //         title: title,
    //         text: progress + "%",
    //         progressBar: { value: progress },
    //         // sound: false
    //     });

    // }catch(err){}

    addProgressVideoToStorage(notificationId, progress);

}
// Rimozione della cartella video/<id> con fallback: se removeRecursively
// fallisce in blocco (es. un file ancora aperto dal player), elimina i file
// uno a uno e poi riprova a togliere la cartella. Risolve sempre.
function removeDownloadDirectory(id) {
    return new Promise((resolve) => {
        window.resolveLocalFileSystemURL(cordova.file.dataDirectory + 'video/' + id, function(directoryEntry) {
            directoryEntry.removeRecursively(function() {
                console.log('Directory ' + id + ' eliminata con successo.');
                resolve(true);
            }, function(error) {
                console.error('removeRecursively fallita per ' + id + ', provo file per file: ' + JSON.stringify(error));
                var reader = directoryEntry.createReader();
                reader.readEntries(function(entries) {
                    var pending = entries.length;
                    var finish = function() {
                        directoryEntry.remove(function() { resolve(true); }, function(err) {
                            console.error('Cartella ' + id + ' non rimossa del tutto: ' + JSON.stringify(err));
                            resolve(false);
                        });
                    };
                    if (!pending) { finish(); return; }
                    entries.forEach(function(entry) {
                        var done = function() { if (--pending === 0) finish(); };
                        if (entry.isDirectory) entry.removeRecursively(done, done);
                        else entry.remove(done, done);
                    });
                }, function() { resolve(false); });
            });
        }, function(error) {
            // cartella già assente: ok
            console.log("Directory video " + id + ' non presente: ' + JSON.stringify(error));
            resolve(true);
        });
    });
}

// Funzione per eliminare un video scaricato
function deleteVideoDownloaded(id) {
    return new Promise((resolve, reject) => {
        // ferma il player nativo se sta tenendo aperti i file del video
        try{
            var _plugins = window.Capacitor && window.Capacitor.Plugins;
            var _player = _plugins && (_plugins.CapacitorVideoPlayer || _plugins.VideoPlayer);
            if (_player && _player.stopAllPlayers) _player.stopAllPlayers();
        }catch(e){}

        db.transaction(function(tx) {
            tx.executeSql('DELETE FROM download WHERE id = ?', [id], function(tx, result) {
                refreshListDownloadedIds();
                removeDownloadDirectory(id).then(function() {
                    refreshListDownloadedIds();
                    // il record non c'è più: allinea il punto rosso della navbar
                    try{ syncDownloadNavBadgeFromDb(); }catch(e){}
                    try{
                        cordova.plugins.notification.local.cancel(id, function() {});
                    }catch(e){}
                    resolve();
                });
            }, function(error) {
                console.error("Errore durante l'eliminazione del video:", error);
                reject(error);
            });
        });
    });
}

async function checkIncompletedDownload() {
    console.log("checkIncompletedDownload");
    try {
        db.transaction(function(tx) {
            tx.executeSql('SELECT * FROM download WHERE progress < 100', [], async function(tx, result) {
                var incompleteIds = [];
                for (var i = 0; i < result.rows.length; i++) {
                    incompleteIds.push(result.rows.item(i).id);
                }

                for (var i = 0; i < incompleteIds.length; i++) {
                    var id = incompleteIds[i];
                    var download_attempts = result.rows.item(i).download_attempts || 0;

                    console.log("Avvia la funzione per l'ID incompleto:", id);
                    download_attempts++;

                    // Se supera i 5 tentativi di download, elimina il video
                    if (download_attempts > 4) {
                        console.log("Troppi tentativi di download, cancello il video " + id);
                        await deleteVideoDownloaded(id);
                    } else {
                        // Altrimenti, ritenta il download e aggiorna il numero di tentativi
                        addProgressVideoToStorage(id, 0)
                        tx.executeSql('UPDATE download SET download_attempts = ? WHERE id = ?', [download_attempts, id]);

                        var title = result.rows.item(i).title;
                        if(result.rows.item(i).title != result.rows.item(i).collection_title){
                            title = result.rows.item(i).collection_title +" - "+ result.rows.item(i).title;
                        }

                        downloadVideoFiles(id, title, result.rows.item(i).quality);
                    }
                }
            }, function(error) {
                console.error("Errore durante il recupero dei dati dal database:", error);
            });
        });
    } catch (error) {
        console.error("Errore durante il recupero dei dati dal database:", error);
    }
}

async function checkExpiredDownload() {
    console.log("checkIncompletedDownload");
    try {
        db.transaction(function(tx) {
            tx.executeSql('SELECT * FROM download', [], async function(tx, result) {
                for (var i = 0; i < result.rows.length; i++) {
                    var id = result.rows.item(i).id;
                    var download_date = new Date(result.rows.item(i).download_date); // Converti la data di download in oggetto Data
                    var deadline = result.rows.item(i).deadline || 0; // Imposta day_expire a 0 se non è definito
                    if(deadline == -1){
                        continue;
                    }
                    // Calcola la data di scadenza aggiungendo day_expire giorni alla data di download
                    var expiration_date = new Date(download_date);
                    expiration_date.setDate(expiration_date.getDate() + deadline);

                    // Ottieni la data attuale
                    var current_date = new Date();

                    // Verifica se la data attuale supera la data di scadenza
                    if (current_date > expiration_date) {
                        console.log("Video scaricato scaduto, cancellare " + id);
                        await deleteVideoDownloaded(id);
                    } else {
                        // Il video è ancora valido
                    }
                }
            }, function(error) {
                console.error("Errore durante il recupero dei dati dal database:", error);
            });
        });

    } catch (error) {
        console.error("Errore durante il recupero dei dati dal database:", error);
    }
}

function addVideoData(id, title=null, collection_title=null, imgURL=null, quality) {
    db.transaction(function(tx) {
        tx.executeSql(
            'SELECT * FROM download WHERE id = ?',
            [id],
            function(tx, result) {
                // Se il record non esiste, esegui l'inserimento
                if (result.rows.length === 0) {

                    var query = 'INSERT INTO download (id, title, collection_title, img, quality, progress, download_attempts, deadline, download_date) VALUES (?, ?, ?, ?, ?, ?, ?, ?, DATETIME("now"))';
                    var params = [id, title, collection_title, imgURL, quality, 0, 0, companyDownloadDeadline];

                    tx.executeSql(
                        query,
                        params,
                        function(tx, result) {

                            if(title != collection_title){
                                title = collection_title +" - "+ title;
                            }

                            console.log("Dati di download salvati con successo nel database.");
                            downloadVideoFiles(id, title, quality);
                            console.log("Video per il download salvato: " + id);
                            window.plugins.toast.showShortBottom(translate('DOWNLOAD_STARTED'));
                        },
                        function(error) {
                            console.error("Errore durante l'inserimento dei dati di download nel database:", error);
                            console.error("Query:", error.query); // Stampare la query che ha causato l'errore
                            console.error("Parametri:", error.params); // Stampare i parametri della query
                        }
                    );
                } else {
                    // Se il record esiste già, mostra un messaggio di toast
                    window.plugins.toast.showShortBottom(translate('VIDEO_ALREADY_DOWNLOADED'));
                }
            },
            function(error) {
                console.error("Errore durante il controllo dell'esistenza del record nel database:", error.message);
            }
        );
    });
}


function debugListFileInDirectory(id){
    console.log("Elenco per directory "+ id);
    let masterFind=false;
        // Directory da cui vogliamo elencare i file (sostituisci con il percorso desiderato)
    var directory = cordova.file.dataDirectory + 'video/'+id+'/';
    // Utilizza la funzione `resolveLocalFileSystemURL` per ottenere l'oggetto DirectoryEntry
    window.resolveLocalFileSystemURL(directory, function(directoryEntry) {
        // Crea un oggetto DirectoryReader per leggere il contenuto della directory
        var directoryReader = directoryEntry.createReader();

        // Leggi i file nella directory
        directoryReader.readEntries(function(entries) {
            // Itera attraverso gli elementi restituiti
            entries.forEach(function(entry) {
                if (entry.isFile) {
                    // Se l'elemento è un file, stampa il suo nome
                    if(entry.name=="master.m3u8"){
                       console.log("-------------MASTER TROVATO: " + entry.name);
                       masterFind=true;
                    }else if(entry.name=="preview.jpg"){
                       console.log("-------------IMG PREVIEW TROVATO: " + entry.name);
                    }else{
                       console.log("File trovato: " + entry.name);
                    }
                } else if (entry.isDirectory) {
                    // Se l'elemento è una directory, stampa il suo nome
                    console.log("Directory trovata: " + entry.name);
                }
            });

            if(masterFind==true){
                console.log("--------MASTER.M3U8 PRESENTE---------");
            }else{
                console.log("--------MASTER.M3U8 NON PRESENTE---------");
            }
        }, function(error) {
            // Gestisci gli errori in caso di problemi durante la lettura della directory
            console.error("Errore durante la lettura della directory: " + error.code);
        });
    }, function(error) {
        // Gestisci gli errori in caso di problemi nel recupero dell'oggetto DirectoryEntry
        console.error("Errore durante l'accesso alla directory: " + error.code);
    });

}



// Funzione per aggiornare le barre di progresso
function updateProgressBars(id, progress) {

    // badge circolare sulla voce Download della navbar
    try{ updateDownloadNavBadge(id, progress); }catch(err){}

    try{
        $('#progress-bar-wrapper-value-'+id).html(progress+'%');
        $('#progress-bar-wrapper-fill-'+id).css('width', progress + '%');

        if (progress == 100) {
            // alert(progress);
            $('#progressBarWrapper-'+id).remove();
            $('.downloadedVideo-'+id).html('<i class="ri-check-line font-size-16"></i>');
        }else{
            $('.downloadedVideo-'+id).html('<i class="ri-download-fill font-size-16"></i> '+progress+'%');
        }
    }catch(err){

    }
}